export const buildEndpoint = (
  baseApiPath: string,
  apiVersion: string,
  service: 'reportservice' | 'reportagent',
  path: string
) => `${baseApiPath}${service}/${apiVersion}${path.startsWith('/') ? '' : '/'}${path}`;

export const API_ENDPOINTS = {
  REPORT_SERVICE: {
    REPORTS: {
      RecentReports: '/api/report/recentreports',
      DeleteReport: '/api/report/delete?reportId={reportId}',
      ReportsByType: '/api/report/reportsByType',
      GetProjectFiles: '/api/report/projectfiles',
      ReportType: '/api/report/reportType',
      Clients: '/api/report/clients',
      States: '/api/report/states',
      Locations: '/api/report/locations',
      ApprovalStatus: '/api/report/status',
      UpdateComments: '/api/report/update/commenthistory',
      GetCharts: '/api/report/chartdata',
      GetReportSections: '/api/report/get-sections?reportId={reportId}',
      AddReportSection: '/api/report/add/reportsection',
      UpdateReportSections: '/api/report/update/reportsections',
      DeleteReportSections: '/api/report/delete/reportsections',
      CreateReport: '/api/report/add-report',
      UpdateValidationRequested: '/api/report/update/validationrequested',
      GenerateReportStatus: '/api/report/generation/status?reportId={reportId}',
      GetReworkSections: '/api/report/reworksections',
      ReportDownload: '/api/report/download?format=blob',
    },
    PERMISSIONS: {
      UserPermissions: '/api/permissions/{id}',
    },
  },
  AGENT_SERVICE: {
    StartOrchestration: '/api/report/start-orchestration',
    GetOrchestrationStatus: '/api/orchestration/status/{reportId}',
    DownloadReport: '/api/report/assembly',
  }
} as const;
